export const projectTypologies = ['RENOVATION', 'RAW', 'MINI_STORE_V2', 'MINI_STORE_V3'] as const
export type ProjectTypology = (typeof projectTypologies)[number]

export const projectTypologyLabel: Record<ProjectTypology, string> = {
  RENOVATION: 'Rénovation',
  RAW: 'Brut',
  MINI_STORE_V2: 'Miniboutique V2',
  MINI_STORE_V3: 'Miniboutique V3',
}
